import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const CodeTabs = makeShortcode("CodeTabs");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><dl parentName="p"><dt parentName="dl"><inlineCode parentName="dt">{`event_id`}</inlineCode></dt><dd parentName="dl">{``}<em parentName="dd">{`Required`}</em>{`. Hexadecimal string representing a uuid4 value. The length is exactly 32
characters. Dashes are not allowed. Has to be lowercase.`}</dd></dl></p>
    <div {...{
      "className": "code-tabs-wrapper"
    }}><CodeTabs mdxType="CodeTabs"><CodeBlock language="json" title="" filename="" mdxType="CodeBlock"><div parentName="div" {...{
            "className": "gatsby-highlight",
            "data-language": "json"
          }}><pre parentName="div" {...{
              "className": "language-json"
            }}><code parentName="pre" {...{
                "className": "language-json"
              }}><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"event_id"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"fc6d8c0c43fc4630ad850ee518f1b9d0"`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span></code></pre></div></CodeBlock></CodeTabs></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      